export default "{\n    \"showMoreLabel\": \"Mostrar más\"\n}\n"